// postMessageToApp.js
'use strict';
import { goBack } from 'redux-first-history';

import {
  getIsOnAndroidWebview,
  getIsOnIOSWebview,
  getIsXUserAgent,
} from '../resource/getUserAgent.js';
import { push } from '../action/navigationAction.js';

/**
 * Post message to SWAG app.
 * @kind action
 * @param {string} {message} - passing message to mobile
 * @param {string} {[fallbackRouteInWebApp]} - when the mobile app API is unavaliable. will fallback to the route
 * @param {Array} {[messageArgs]} - array of additional arguments to pass to the webview handler
 * @return {Promise} Action promise.
 */
const postMessageToApp =
  ({ message, fallbackRouteInWebApp, messageArgs = [] }) =>
  async dispatch => {
    if (!message) return false;

    if (getIsXUserAgent()) {
      // new method to post message to app
      window.WebApp?.callHandler?.(message, ...messageArgs);
    }

    // backward compatibility for Android
    if (getIsOnAndroidWebview()) {
      if (message === 'actionUrl' && messageArgs?.[0]) {
        return window.WebApp?.postMessage?.(messageArgs[0]);
      }

      return window.WebApp?.postMessage?.(message);
    }

    // backward compatibility for iOS
    if (getIsOnIOSWebview()) {
      if (message === 'actionUrl' && messageArgs?.[0]) {
        return window.webkit?.messageHandlers?.WebApp?.postMessage?.(
          messageArgs[0]
        );
      }
      return window.webkit?.messageHandlers?.WebApp?.postMessage?.(message);
    }

    if ('closeWebView' === message) {
      if ('home' === fallbackRouteInWebApp) {
        return dispatch(push('/'));
      } else {
        return dispatch(goBack());
      }
    }

    if (fallbackRouteInWebApp) {
      return dispatch(push(fallbackRouteInWebApp));
    }
  };

export default postMessageToApp;
